import {TriggerAttachment} from 'src/openapi/models/TriggerAttachment';

export const isAttachmentUpdated = (
    attachment: TriggerAttachment,
    existingTriggerAttachments?: TriggerAttachment[],
): boolean => {
    if (!existingTriggerAttachments?.length) {
        return true;
    }

    const existing =
        existingTriggerAttachments.find(existingAttachment => existingAttachment.name === attachment.name);

    return attachment.active !== existing?.active;
};
